const ImageCarousel = (settings) => {
    return (<div id={settings.id} className="carousel slide">
        <div className="carousel-indicators left-indicators ml-3">
            {settings.images.map((image, index) => (
                <button key={index} type="button" data-bs-target={'#' + settings.id} data-bs-slide-to={index} className={index === 0 ? "active" : ""} aria-current={index === 0} aria-label={"Slide " + (index + 1)}></button>
            ))}
        </div>
        <div className="carousel-inner">
            {settings.images.map((image, index) => (
                <div key={index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                    <img src={image} className="d-block w-100 rounded-3" alt="..." />
                </div>
            ))}
        </div>
    </div>);
};

export default ImageCarousel;